import { Pipe, PipeTransform, Injectable } from '@angular/core';

@Pipe({ name: 'iconMapper' })
@Injectable()
export class IconMapperPipe implements PipeTransform {
  transform(
    value: boolean | 'N/A' | null | undefined,
    trueIcon: string,
    falseIcon: string,
    naIcon: string,
    prefix = '/assets/images/icon-indicator-'
  ): string {
    if (value === true) {
      return `${prefix}${trueIcon}`;
    } else if (value === false) {
      return `${prefix}${falseIcon}`;
    } else if (value === 'N/A' || value == null) {
      return `${prefix}${naIcon}`;
    }
  }
}
